export default __webpack_public_path__ + "static/media/energie-active.14e0b292.svg";